var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 11.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 11.75,
    stroke: "#A5DCF3",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45455 7C4.64727 7 4.00424 7.65202 4.00953 8.46521L4.04766 14.326H5.50221C5.51012 15.5422 6.49105 16.5239 7.69832 16.5239C8.9056 16.5239 9.87375 15.5422 9.86584 14.326H14.2295C14.2374 15.5422 15.2183 16.5239 16.4256 16.5239C17.6329 16.5239 18.601 15.5422 18.5931 14.326H20.0477L20.0286 11.3956C20.0233 10.5824 19.3718 9.93042 18.5645 9.93042L16.3636 7H5.45455ZM14.189 8.09891H16.0071L17.4445 9.93042H14.2009L14.189 8.09891ZM7.67688 13.2271C8.28051 13.2271 8.77098 13.718 8.77493 14.326C8.77889 14.9341 8.29481 15.4249 7.69117 15.4249C7.08754 15.4249 6.59707 14.9341 6.59312 14.326C6.58916 13.718 7.07324 13.2271 7.67688 13.2271ZM16.4041 13.2271C17.0078 13.2271 17.4983 13.718 17.5022 14.326C17.5062 14.9341 17.0221 15.4249 16.4184 15.4249C15.8148 15.4249 15.3243 14.9341 15.3204 14.326C15.3164 13.718 15.8005 13.2271 16.4041 13.2271Z",
    fill: "#20A8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceVehicle);
export default __webpack_public_path__ + "static/media/sourceVehicle.3c3a2369cff235e2d8fb50d82802f83a.svg";
export { ForwardRef as ReactComponent };